import React from 'react';
import PropTypes from 'prop-types';

import Avatar from "./avatar";

const Summary = ({ user }) => (
	<div className="d-flex">
		<Avatar user={user} />
		<div className="flex-fill">
			<p className="mb-0 text-black-secondary">Owner:</p>
			<p className="mb-0">{user.name}</p>
		</div>
	</div>
)

Summary.propTypes = {
	user: PropTypes.object.isRequired
}

export default Summary;